import { Message } from 'Components/Core';
import { PageSection } from 'Components/Layout';
import { WorksheetCheckedBySection, WorksheetTestedBySection } from '../Core';
import { WorksheetRootComponent } from '../Core/types';

const qestIds: Array<string> = [];

let UnsupportedWorksheet: WorksheetRootComponent = () => {
  return (
    <>
      <PageSection>
        <Message severity="info">
          This worksheet is not supported in the QEST Web App and must be accessed through either QESTLab or QESTField.
        </Message>
      </PageSection>
      <PageSection>
        <WorksheetTestedBySection />
      </PageSection>
      <PageSection>
        <WorksheetCheckedBySection />
      </PageSection>
    </>
  );
};

UnsupportedWorksheet.qestIds = qestIds;
export default UnsupportedWorksheet;
